<template>
    <div class="page">
        <Nav defaultPath="/companyNews"></Nav>
        <div class="banner">
            <div class="msgBox">
                <div class="txt1">{{ $t('bannerTxt.title1') }}</div>
                <div class="txt2">{{ $t('bannerTxt.msg1') }}</div>
            </div>
            <img src="https://4d-ai.chat/img/banner4.png"></img>
        </div>
        <div class="main  needVisible">
            <div class="headline">{{ $t('nav.nav4') }}</div>
            <div class="scenes">
                <div class="sceneItem" @click="jump(item)" v-for="(item, index) in list">
                    <img :src="`https://4d-ai.chat/img/fm${index + 1}.jpg`" />
                    <div class="txt">
                        <div class="title">{{ $t(`news.title${index + 1}`) }}</div>
                        <div class="content">{{ $t(`news.date${index + 1}`) }}</div>
                    </div>
                </div>
            </div>
        </div>
        <ContactUs></ContactUs>
        <div class="totop" @click.stop="toTop()" v-if="showGoTop">
            <img src="https://4d-ai.chat/img/totop.png">
        </div>
    </div>
</template>
<script>
import Nav from '@/components/Nav.vue';
import ContactUs from '@/components/ContactUs.vue';
export default {
    components: {
        Nav,
        ContactUs
    },
    data() {
        return {
            list: [
                'https://mp.weixin.qq.com/s/jYXBqmLNn6MiJZuFnhJm5Q',
                'https://mp.weixin.qq.com/s/AQw3QPjZT94udo3C0otVqg',
                'https://mp.weixin.qq.com/s/MNXeACN7Mb4U28PnasLfEw',
                'https://mp.weixin.qq.com/s/Wc-P-Rbjc6thsxN0GByvfA',
                'https://mp.weixin.qq.com/s/tHyDXK3UZq_nVPwk03TeyA',
            ],
            showGoTop: false,
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll, true);
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                } else {
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });
        const boxes = document.querySelectorAll('.needVisible');
        boxes.forEach(box => {
            observer.observe(box);
        });
    },
    methods: {
        language() {
            return localStorage.getItem('languageSet')
        },
        handleScroll() {
            let scrolltop = document.documentElement.scrollTop;
            if (scrolltop > window.innerHeight) {
                this.showGoTop = true
            } else {
                this.showGoTop = false
            }
        },
        toTop() {
            document.documentElement.scrollTop = 0;
        },
        jump(url) {
            window.open(url, '_blank');
        },
    }
}
</script>
<style scoped lang="less">
@media (max-width: 768px) {
    .sceneItem {
        width: 48% !important;
        margin: 0 0 10px 0 !important;
    }

    .content {
        font-size: 10px !important;
    }

    .title {
        font-size: 12px !important;
    }

    .scenes {
        justify-content: space-between !important;
    }

    .sceneItem {
        img {
            border-radius: 5px !important;
        }
    }


    .main {
        padding: 10px !important;
    }

    .headline {
        font-size: 18px !important;
        margin-bottom: 10px !important;
    }

    .page {
        padding: 40px 0 0 !important;
    }

    .totop {
        width: 48px !important;
        bottom: 100px !important;
        height: 56px !important;
    }

    .msgBox {
        width: 100% !important;
    }

    .txt1 {
        font-size: 20px !important;
    }

    .txt2 {
        font-size: 12px !important;
    }
}
</style>
<style scoped lang="less">
.page {
    box-sizing: border-box;
    padding: 64px 0 0;

    .needVisible {
        opacity: 0;
        transform: translateY(20px);
        transition: all 1s ease-out;
    }

    .visible {
        opacity: 1;
        transform: translateY(0);
    }

    .totop:hover {
        background: #2743af;
    }

    .totop {
        width: 48px;
        height: 56px;
        background-color: #243c8a;
        position: fixed;
        z-index: 20;
        right: 30px;
        bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        cursor: pointer;

        img {
            width: 45%;
        }
    }

    .headline {
        font-weight: 600;
        font-size: 36px;
        color: #243c8a;
        text-align: center;
        margin-bottom: 64px;
    }

    .main {
        background-color: #fff;
        padding: 80px 212px 30px;
        box-sizing: border-box;

        .scenes {
            display: flex;
            flex-wrap: wrap;
            // background-color: pink;
            gap: 30px;

            .sceneItem:hover {
                box-shadow: 0 2px 50px #0000001a;
                transform: translate(0, -10px)
            }

            .sceneItem {
                width: 271.5px;
                background-color: #fff;
                box-shadow: 0 2px 8px #0000001a;
                border-radius: 15px;
                overflow: hidden;
                box-sizing: border-box;
                transition: all 0.3s;
                cursor: pointer;
                display: flex;
                flex-direction: column;

                .txt {
                    flex: 1;
                    background-color: #fff;
                    padding: 12px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #243c8a;
                        margin-bottom: 5px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .content {
                        font-size: 14px;
                        color: #4c5563;
                    }
                }

                img {
                    width: 100%;
                }
            }
        }
    }

    .banner {
        width: 100%;
        display: flex;
        position: relative;

        .msgBox {
            position: absolute;
            text-align: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;

            .txt1 {
                font-size: 60px;
                font-weight: 600;
            }

            .txt2 {
                font-size: 25px;
            }
        }

        img {
            width: 100%;
            top: 0;
            left: 0;
        }
    }
}
</style>